
import { css } from 'lit';
export default css`
pc-promo-card [slot='image'] pc-image img, 
pc-promo-card [slot='image']{
  height:100%;
  width:100%;
}

pc-promo-card:hover [slot='cta'] a,
  pc-promo-card:hover [slot='content'],
  pc-promo-card:hover [slot='content'] .heading-promo-card,
  pc-promo-card:hover pc-wysiwyg{
    color:var(--primary-white);
  }

pc-promo-card pc-wysiwyg{
  color:var(--neutral-medium-gray);
  margin-top:0.5rem;
}

pc-promo-card pc-link{
  --link-border-color:transparent;
}

pc-promo-card[dark] pc-tag{
  --tag-bg-override:var(--primary-white);
}
`;